<template>
  <div>
    <div>United States Only</div>
    <div class="hyp-power-outage-legend-container">
      <div>
        <v-row class="pt-3 px-2 legend-spacing">
          <div class="box-normal"></div>
          <span class="text-wrap">Normal: no anomalies in last 6 hours</span>
        </v-row>
        <v-row class="pt-3 px-2 legend-spacing">
          <div class="box-fluctuation"></div>
          <span class="text-wrap"
            >Fluctuating: 1-5 consecutive anomalies in last 6 hours</span
          >
        </v-row>
        <v-row class="pt-3 px-2 legend-spacing">
          <div class="box-outage"></div>
          <span class="text-wrap"
            >Impaired: 6 consecutive anomalies in last 6 hours</span
          >
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MODULE_PREFIX_MAP_CONTROLS,
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_MAP,
  MODULE_PREFIX_POWER_OUTAGE,
} from "@/store";
import {
  GET_COUNTY_DETAILS,
  GET_DETAILS_SIDEBAR,
  GET_POWER_OUTAGE_REFRESH_MAP,
} from "@/store/actions.type";
import { removeMapData, mapPolygonData } from "@/common/maps/features";
import { MAIN_MAP_ID } from "@/common/constants/maps";
import { getDefaultMarkerOptions } from "@/common/maps/styles";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";
import { waitForMapReady } from "@/common/maps/maps";
import { getFirstMarkerLayer } from "@/common/maps/layers";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { POWER_OUTAGE } from "@/common/config";
import {
  MAP_LAYER_METADATA_POWER_OUTAGE,
  OVERLAYS_SECTION_POWER_OUTAGE,
  POWER_OUTAGE_US48_BOUNDS,
} from "@/common/constants/mapControls";

import { mapGetters } from "vuex";

export default {
  name: "MapControlsOverlayPowerOutage",
  components: {},
  data: () => ({
    layerId: MAP_LAYER_METADATA_POWER_OUTAGE,
  }),
  computed: {
    ...mapGetters({
      maps: MODULE_PREFIX_MAP + "maps",
      mainMapHijacker: MODULE_PREFIX_MAP + "mainMapHijacker",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
      mapControlParams: MODULE_PREFIX_MAP_CONTROLS + "params",
      refreshMap: MODULE_PREFIX_POWER_OUTAGE + "refreshMap",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
  },
  methods: {
    addToMap(moveMap) {
      const firstPointsLayerId = getFirstMarkerLayer(this.map);

      const LAYER_ID = this.layerId;

      const PARAMS = {
        id: LAYER_ID,
        noCluster: false,
      };

      const layerOptions = {
        polygonLayerOptions: {
          id: LAYER_ID,
          metadata: MAP_LAYER_METADATA_POWER_OUTAGE,
          type: "fill",
          source: LAYER_ID,
          paint: {
            "fill-color": [
              "case",
              ["==", ["get", "c"], "red"],
              "#f8887a",
              ["==", ["get", "c"], "yellow"],
              "#f4f63d",
              "#7e7f80",
            ],
            "fill-opacity": 0.4,
          },
        },
      };

      const OPTIONS = getDefaultMarkerOptions(PARAMS);
      /*
       * OPTIONS
       * id:  source ID
       * data: endpoint for markers
       * mapClickEvent: function when markers are clicked
       * polygonOptions:  options for polygons
       * map:  map object
       * */
      mapPolygonData({
        id: LAYER_ID,
        data: `${POWER_OUTAGE}/countyMap_outage.json`,
        mapClickEvent: this.mapClickEvent,
        markerOptions: OPTIONS,
        map: this.map,
        polygonOptions: layerOptions,
        beforeLayer: firstPointsLayerId,
      });

      if (moveMap) {
        const bbox = POWER_OUTAGE_US48_BOUNDS;
        this.map.fitBounds(bbox, {});
      }
    },
    async mapClickEvent(e, features) {
      e.originalEvent.stopPropagation();

      if (features.length > 0) {
        setTimeout(async () => {
          this.detailsSidebar.visible = true;

          this.detailsSidebar.selected = DETAIL_SIDEBAR_TYPES.powerOutage;
          this.detailsSidebar.type = DETAIL_SIDEBAR_TYPES.powerOutage;
          const NAME = `layer-${features[0].properties.t}`;

          const PARAMS = {
            title: NAME,
            feature: features[0],
          };
          this.$store.dispatch(
            MODULE_PREFIX_POWER_OUTAGE + GET_COUNTY_DETAILS,
            PARAMS
          );

          await this.$store.dispatch(
            MODULE_PREFIX_HOME + GET_DETAILS_SIDEBAR,
            this.detailsSidebar
          );

          this.handlePageTrackerEvent(
            EVENT_CATEGORIES.powerOutage,
            EVENT_ACTIONS.clicked,
            `County Click --- ${features[0].properties.i}`
          );
        }, 300);
      }
    },
    removeFromMap() {
      if (this.map) {
        removeMapData(this.map, this.layerId);
      }
    },
    handleMapRefresh(force) {
      if (this.refreshMap || force) {
        if (
          this.mapControlParams?.mapOverlaysControlEnabled &&
          this.mapControlParams?.mapOverlaysControlSelectedType ===
            OVERLAYS_SECTION_POWER_OUTAGE &&
          !this.mainMapHijacker
        ) {
          const moveMap = force;
          this.attemptAddToMap(moveMap);
        } else {
          this.removeFromMap();
        }
        this.$store.dispatch(
          MODULE_PREFIX_POWER_OUTAGE + GET_POWER_OUTAGE_REFRESH_MAP,
          false
        );
      }
    },
    async attemptAddToMap(moveMap, attemptCount = 0) {
      if (!this.map && attemptCount < 50) {
        setTimeout(() => {
          this.attemptAddToMap(moveMap, attemptCount + 1);
        }, 500);
      } else {
        await waitForMapReady(this.map);
        this.addToMap(moveMap);
      }
    },
  },
  watch: {
    mainMapHijacker: {
      handler(newVal, oldVal) {
        this.handleMapRefresh(newVal !== oldVal);
      },
    },
    refreshMap: {
      handler() {
        this.handleMapRefresh();
      },
      deep: true,
      immediate: true,
    },
    "mapControlParams.mapOverlaysControlEnabled": {
      handler() {
        this.handleMapRefresh("true");
      },
      deep: true,
      immediate: true,
    },
    "mapControlParams.mapOverlaysControlSelectedType": {
      handler() {
        this.handleMapRefresh("true");
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.hyp-power-outage-legend-container {
  padding: 0 !important;
  display: grid;
  grid-template-columns: 300px auto;
}
.box-normal {
  border: 1px solid #555353;
  background: #7e7f80;
  height: 30px;
  width: 30px;
}
.box-fluctuation {
  border: 1px solid #b8b92d;
  background: #f4f63d;
  height: 30px;
  width: 30px;
}
.box-outage {
  border: 1px solid #ba655b;
  background: #f8887a;
  height: 30px;
  width: 30px;
}
[class*="box-"] {
  border-radius: 3px;
}
.text-wrap {
  inline-size: 250px;
  overflow-wrap: break-word;
  padding-left: 0.5rem;
  margin-top: -0.5rem;
}
.legend-spacing {
  padding-left: 2rem;
  margin-top: 0.5rem;
}
</style>
